import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isTranspose } from '../utils/coordinate';
/**
 * Scale mark from desired shape to nothing in y direction.
 */
export var ScaleOutY = function ScaleOutY(options, context) {
  // Small enough to hide or show very small part of mark,
  // but bigger enough to not cause bug.
  var ZERO = 0.0001;
  var coordinate = context.coordinate;
  return function (from, _, defaults) {
    var _from = _slicedToArray(from, 1),
      shape = _from[0];
    var _shape$getBoundingCli = shape.getBoundingClientRect(),
      height = _shape$getBoundingCli.height;
    var _shape$style = shape.style,
      _shape$style$transfor = _shape$style.transform,
      prefix = _shape$style$transfor === void 0 ? '' : _shape$style$transfor,
      _shape$style$fillOpac = _shape$style.fillOpacity,
      fillOpacity = _shape$style$fillOpac === void 0 ? 1 : _shape$style$fillOpac,
      _shape$style$strokeOp = _shape$style.strokeOpacity,
      strokeOpacity = _shape$style$strokeOp === void 0 ? 1 : _shape$style$strokeOp,
      _shape$style$opacity = _shape$style.opacity,
      opacity = _shape$style$opacity === void 0 ? 1 : _shape$style$opacity;
    var _ref = isTranspose(coordinate) ? [[0, 0], "scale(".concat(ZERO, ", 1)")] // left-top corner
      : [[0, height], "scale(1, ".concat(ZERO, ")")],
      _ref2 = _slicedToArray(_ref, 2),
      transformOrigin = _ref2[0],
      transform = _ref2[1]; // left-bottom corner
    // Using a short fadeIn transition to hide element with scale(0.001)
    // which is still visible.
    var keyframes = [{
      transform: "".concat(prefix, " scale(1, 1)").trimStart()
    }, {
      transform: "".concat(prefix, " ").concat(transform).trimStart(),
      fillOpacity: fillOpacity,
      strokeOpacity: strokeOpacity,
      opacity: opacity,
      offset: 0.99
    }, {
      transform: "".concat(prefix, " ").concat(transform).trimStart(),
      fillOpacity: 0,
      strokeOpacity: 0,
      opacity: 0
    }];
    // Change transform origin for correct transform.
    shape.setOrigin(transformOrigin);
    var animation = shape.animate(keyframes, Object.assign(Object.assign({}, defaults), options));
    // Reset transform origin to eliminate side effect for following animations.
    animation.finished.then(function () {
      return shape.setOrigin(0, 0);
    });
    return animation;
  };
};